import { queryOptions } from "@tanstack/react-query";
import { fetchChartPermissions, fetchDetailPermissions, fetchListPermissions, fetchPermissionConfig, fetchPermissions, fetchReportPermissions } from "./permissions";

export const fetchPermissionsQueryOptions = (entity: string, identifier: string) =>
    queryOptions({
        queryKey: ['permission', entity, identifier],
        queryFn: () => fetchPermissions(entity, identifier),
        staleTime: 1000 * 15, // 15 seconds
    })

export const fetchDetailPermissionsQueryOptions = (entity: string, identifier: string, details: string[]) =>
    queryOptions({
        queryKey: ['detailPermission', entity, identifier, details.join(',')],
        queryFn: () => fetchDetailPermissions(entity, identifier, details),
        staleTime: 1000 * 15, // 15 seconds
    })

export const fetchListPermissionsQueryOptions = (list: string[]) =>
    queryOptions({
        queryKey: ['permission', list],
        queryFn: () => fetchListPermissions(list),
        staleTime: 1000 * 15, // 15 seconds
    })

export const fetchReportPermissionsQueryOptions = (report: string[]) =>
    queryOptions({
        queryKey: ['permission', report],
        queryFn: () => fetchReportPermissions(report),
        staleTime: 1000 * 15, // 15 seconds
    })

export const fetchChartPermissionsQueryOptions = (chart: string[]) =>
    queryOptions({
        queryKey: ['permission', chart],
        queryFn: () => fetchChartPermissions(chart),
        staleTime: 1000 * 15, // 15 seconds
    })

export const fetchPermissionConfigQueryOptions = () =>
    queryOptions({
        queryKey: ['permission', 'config'],
        queryFn: () => fetchPermissionConfig(),
        staleTime: 1000 * 15, // 15 seconds
    })     